export function FormatPhoneNumber(input?:string): string {
    if(input?.length) {
        const digits = input.replace(/\D/g, '');
        const x = digits.match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        if(x) {
            return !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
        }
    }
    return "";
}